import * as ladda from './as-ladda-controller';
import * as withRequests from './with-requests';
import * as toast from './with-toast-notifications';
import * as clickOutside from './click-outside';
import * as serialization from './serialization';
import * as withDocumentTitle from './with-document-title';

// Export hoc namespace i.e.: `import {hoc} from '@canimmunize/core-imports'`
export const hoc = {
    ladda,
    withRequests,
    toast,
    clickOutside,
    serialization,
    withDocumentTitle,
};

// Export all items from hocs individually (in "global" @core-imports namespace)
export * from './as-ladda-controller';
export * from './with-requests';
export * from './with-toast-notifications';
export * from './click-outside';
export * from './serialization';
export * from './with-document-title';
